/**
 * Authentication Context - Global auth state management
 */
import React, { createContext, useState, useEffect } from 'react';
import { storage } from '../utils/storage';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initialize auth state from storage
  useEffect(() => {
    const token = storage.getToken();
    const username = storage.getUsername();
    const userId = storage.getUserId();
    const perms = storage.getPermissions();

    if (token && username) {
      setIsAuthenticated(true);
      setUser({ username, id: userId });
      setPermissions(perms);
    }

    setLoading(false);
  }, []);

  const login = (token, username, userId, permissions) => {
    storage.setAuth(token, username, userId, permissions);
    setIsAuthenticated(true);
    setUser({ username, id: userId });
    setPermissions(permissions);
  };

  const logout = () => {
    storage.clearAuth();
    setIsAuthenticated(false);
    setUser(null);
    setPermissions(null);
  };

  const hasPermission = (permission) => {
    if (!permissions) return false;
    if (permissions.is_admin) return true;

    // Backend sends permissions without "can_access_" prefix (e.g., "sales", "dashboard")
    return permissions[permission] === true;
  };

  const value = {
    isAuthenticated,
    user,
    permissions,
    loading,
    login,
    logout,
    hasPermission,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
